/* eslint-disable */

/** unique or primary key constraints on table "argo.audit" */
export enum ArgoAuditConstraint {
  /** unique or primary key constraint on columns "audit_id" */
  AuditPkey = 'audit_pkey'
}

/** select columns of table "argo.audit" */
export enum ArgoAuditSelectColumn {
  /** column name */
  Action = 'action',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  Meta = 'meta',
  /** column name */
  PkBigint = 'pk_bigint',
  /** column name */
  PkText = 'pk_text',
  /** column name */
  PkUuid = 'pk_uuid',
  /** column name */
  Schema = 'schema',
  /** column name */
  Table = 'table'
}

/** update columns of table "argo.audit" */
export enum ArgoAuditUpdateColumn {
  /** column name */
  Action = 'action',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  Meta = 'meta',
  /** column name */
  PkBigint = 'pk_bigint',
  /** column name */
  PkText = 'pk_text',
  /** column name */
  PkUuid = 'pk_uuid',
  /** column name */
  Schema = 'schema',
  /** column name */
  Table = 'table'
}

